import {Component, Input, OnInit} from '@angular/core';
import {Segmento} from '../../../_models/segmento';
import {SegmentosOcupaciones} from '../../../_models/segmentos-ocupaciones';
import {Ocupaciones} from '../../../_models/ocupaciones';
import {forkJoin} from 'rxjs';
import {NavService} from '../../../_services/_nav.service';
import {OcupacionesService} from '../../../_services/ocupaciones.service';
import {SegmentosOcupacionesService} from '../../../_services/segmentos-ocupaciones.service';

@Component({
  selector: 'app-segmento-ocupaciones',
  templateUrl: './segmento-ocupaciones.component.html',
  styleUrls: ['./segmento-ocupaciones.component.css']
})
export class SegmentoOcupacionesComponent implements OnInit {
  @Input() segmento: Segmento;
  listaOcupaciones: Ocupaciones[] = [];
  ocupacionesSeleccionadas: Ocupaciones[] = [];
  listaSegmentoOcupaciones: SegmentosOcupaciones[] = [];
  listaTodasOcupaciones: Ocupaciones[] = [];
  carInformacionInicial = true;
  save = false;
  constructor(private tiposOcupaciones: OcupacionesService,
              private navServicio: NavService,
              private segmentosOcupaciones: SegmentosOcupacionesService) { }

  ngOnInit() {

    forkJoin( this.segmentosOcupaciones.listaxIdSegmento( this.segmento.idSegmento ),
      this.tiposOcupaciones.listByNivel(4)).subscribe( ( [ listaSegmentosOcupaciones, listaOcupaciones ] ) => {
      this.listaSegmentoOcupaciones = listaSegmentosOcupaciones;
      this.listaTodasOcupaciones = [ ...listaOcupaciones ];
      this.loadLists();
      this.carInformacionInicial = false;
    } );
  }


  loadLists() {
    this.listaTodasOcupaciones.map( ocupacion => {
      if ( this.listaSegmentoOcupaciones.find( sa => sa.idOcupacion === ocupacion.idOcupacion && sa.indicadorHabilitado ) ) {
        this.ocupacionesSeleccionadas.push(ocupacion);
        this.ocupacionesSeleccionadas = [ ...this.ocupacionesSeleccionadas ];
      } else {
        if ( ocupacion.indicadorHabilitado ) {
          this.listaOcupaciones.push( ocupacion );
          this.listaOcupaciones = [ ...this.listaOcupaciones ];
        }
      }
    } );
  }


  guardar(event: Ocupaciones[], seleccionado: boolean ) {
    this.save = true;
    const registros = [];
    event.map( e => {
      const a = this.listaSegmentoOcupaciones.findIndex( sa => sa.idOcupacion === e.idOcupacion );
      const temp: SegmentosOcupaciones = {
        id: a >= 0 ? this.listaSegmentoOcupaciones[ a ].id : null,
        idSegmentoOcupacion: a >= 0 ? this.listaSegmentoOcupaciones[ a ].idSegmentoOcupacion : null,
        idSegmento: this.segmento.idSegmento,
        segmento: this.segmento.nombre,
        idOcupacion: e.idOcupacion,
        ocupacion: e.ocupacion,
        indicadorHabilitado: seleccionado,
        auditoriaUsuario: null,
        auditoriaFecha: null
      };
      if ( a >= 0 ) {
        this.listaSegmentoOcupaciones[ a ].indicadorHabilitado = seleccionado;
      } else {
        this.listaSegmentoOcupaciones.push( temp );
      }
      registros.push( temp );
    } );
    this.segmentosOcupaciones.bulk( registros ).subscribe( res => {
      if ( seleccionado ) {
        res.map( ( s: SegmentosOcupaciones ) => {
          const a = this.listaSegmentoOcupaciones.findIndex( x => x.idOcupacion == s.idOcupacion && !x.idSegmentoOcupacion );
          if ( a >= 0 ) {
            this.listaSegmentoOcupaciones[ a ].idSegmentoOcupacion = s.idSegmentoOcupacion;
          }
        } );
      }
      this.navServicio.setMesage( 2 );
      this.save = false;
    } );

  }

}
